angular.module("vgresiduos").controller("CollectionRequestEquipmentCreateCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `gestao-solicitacoes/equipamento/nova`);
		};
	}
]);
